export const EDTIOR_RESTRICTION_SOURCES = {
    editor_less_512gb: 'editor_less_512gb',
    mnz_editor_less_512gb: 'mnz_editor_less_512gb',
    balloon_editor_less_512gb: 'balloon_editor_less_512gb',
    touch_editor_less_512gb: 'touch_editor_less_512gb',
} as const;

export const getUtmQuery = (utm_campaign) => `utm_source=cloud&utm_medium=web_union_quota_landing&utm_campaign=${utm_campaign}`;
